/* global  BMapGL */
import { loadBMap } from './loadBMap';
import { basicConfig } from './mapConfig';

loadBMap();

const { centerPointLongitude: longitude, centerPointLatitude: latitude, mapZoom } = basicConfig;

class MapBase {
    constructor(elem, rowData) {
        // 实例化地图对象
        this.map = new BMapGL.Map(elem);
        // 允许地图可被鼠标滚轮缩放
        this.map.enableScrollWheelZoom();
        // 开启地图的平移缩放控件
        this.addNavigationControl();
        // 定义坐标点
        this.point = this.toAxisPoint(rowData.arrivalLongitude || longitude, rowData.arrivalLatitude || latitude);
        // 设置默认中心点
        this.setDefaultCenterPoint();
        // 添加点标注
        this.addPoint();
        // 创建信息窗口
        this.createInfoWindow(rowData);
    }

    // 添加标记点
    addPoint () {
        const marker = new BMapGL.Marker(this.point);
        this.map.addOverlay(marker);
    }

    // 添加标记点信息窗口
    createInfoWindow (rowData) {
        const point = this.point;
        const marker = new BMapGL.Marker(point);
        this.map.addOverlay(marker);
        const opts = {
            width: 200,
            height: 100,
            title: '当前位置：'
        };
        const content = (data) => {
            return `<div>${data}</div>`;
        };
        // 创建信息窗口对象
        const infoWindow = new BMapGL.InfoWindow(content(rowData.arrivalDriverAddress), opts);
        // 开启信息窗口
        this.map.openInfoWindow(infoWindow, point);
        // 注册点击事件
        marker.addEventListener('click', function () {
            this.map.openInfoWindow(infoWindow, point);
        });
    }

    // 开启地图的平移缩放控件
    addNavigationControl () {
        const zoomCtrl = new BMapGL.ZoomControl(); // 添加缩放控件
        this.map.addControl(zoomCtrl);
    }

    // 设置默认中心点
    setDefaultCenterPoint () {
        this.map.centerAndZoom(this.point, mapZoom);
    }

    /**
     * @description 将经纬度转为坐标点
     * @param {Objcet} longitude 经度
     * @param {Objcet} latitude 纬度
     */
    toAxisPoint (longitude, latitude) {
        return new BMapGL.Point(longitude, latitude);
    }
}

export default MapBase;
